<template>
  <div class="login">
    <div class="login__top">
      <div class="login__inner">
        <div class="box">
          <af-h1>Hitta ny kompetens!</af-h1>
          <p>
            Med Jobskills kan du hitta rätt person för jobbet och fånga upp ny
            kompetens tidigt. Här kan du nå arbetssökande personer som är nya i
            Sverige. De arbetssökande beskriver själva sin utbildning och
            erfarenhet och ansvarar för informationen i sin kompetensprofil.
          </p>
          <div class="box__footer">
            <af-button @clicked="login" buttonStyle="nis-primary" lowercase
              >Sök kompetens i Jobskills</af-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="login__middle">
      <div class="login__inner">
        <div class="box--middle">
          <af-h2 noMarginTop>Att anställa personer som är nya i Sverige</af-h2>
          <p>
            När du anställer personer som är nya i Sverige har du chans att
            fånga ny kompetens tidigt samtidigt som du bidrar till
            integrationen.
          </p>
          <router-link
            class="box--middle-link"
            target="_blank"
            to="/arbetsgivarinformation"
          >
            <icon link type="angle-right"></icon>
            Läs mer om att anställa personer som är nya i Sverige
          </router-link>
        </div>

        <div class="box--middle">
          <af-h2 noMarginTop>Vad är Jobskills?</af-h2>
          <p>
            Jobskills är ett digitalt verktyg där personer som är nya i Sverige
            kan göra ett cv på sitt förstaspråk via valbara alternativ.
            Kompetensprofilerna översätts till svenska, och du som arbetsgivare
            kan söka efter kandidater utifrån erfarenheter, kompetenser och
            utbildning.
          </p>
          <router-link class="box--middle-link" to="/om-jobskills">
            <icon link type="angle-right"></icon>
            Läs mer om Jobskills
          </router-link>
        </div>
      </div>
    </div>

    <div class="login__bottom">
      <div class="login__inner">
        <div class="box box--bottom">
          <af-h2 noMarginTop>Hur får jag tillgång till sökverktyget?</af-h2>
          <p>
            För att få tillgång till Jobskills sökverktyg behöver du ha ett
            arbetsgivarkonto hos Arbetsförmedlingen. Med arbetsgivarkontot får
            du också tillgång till andra tjänster hos Arbetsförmedlingen, t.ex.
            möjligheten att lägga upp annonser på Platsbanken.
          </p>
          <external-link
            class="box--middle-link"
            href="https://arbetsformedlingen.se/for-arbetsgivare/skapa-arbetsgivarkonto#/valjforetag"
            >Skapa ett arbetsgivarkonto</external-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AfH1 from '@/components/AfH1'
import AfH2 from '@/components/AfH2'
import Button from '@/components/Button/Button'
import AfLink from '@/components/AfLink'
import ExternalLink from '@/components/ExternalLink'
import Icon from '@/components/Icon'

export default {
  components: {
    'af-button': Button,
    AfH1,
    AfH2,
    AfLink,
    ExternalLink,
    Icon
  },
  name: 'login',
  methods: {
    login() {
      if (this.$store.getters.loggedIn) {
        this.$router.push('/sok')
      } else {
        window.location.href = `${__API_URL__}auth/saml?returnUrl=${__BASE_URL__}sok`
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.login__top,
.login__bottom {
  background-image: url('../../static/img/arbetsgivare_top.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 500px;
  display: flex;
  background-position-y: -var(--spacing-huge);
  align-items: center;

  @media (--bp-nis-large) {
    background-position-y: -var(--spacing-even-huger);
  }
}

.login__top {
  height: 650px;
}

.login__inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;

  @media (--bp-desktop-xlarge) {
    padding: 0;
    width: var(--spacing-max-width-large);
  }
}

.login__middle {
  background-color: var(--color-white);

  @media (--bp-desktop-xlarge) {
    padding: 100px 0;
  }
}

.login__bottom {
  background-image: url('../../static/img/login_bottom.jpg');
  background-position: center center;
  height: 500px;

  @media (--bp-desktop) {
    height: 700px;
  }
}

.box {
  background-color: var(--color-white);
  padding: var(--spacing);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);

  @media (--bp-desktop) {
    max-width: var(--spacing-max-width-medium);
    padding: var(--spacing-large);

    & button {
      margin-top: var(--spacing);
    }
  }
}

.box--middle {
  margin-bottom: 30px;
  max-width: 550px;
  width: 100%;

  @media (--bp-desktop) {
    margin-bottom: 0;
  }
}

.box--middle-link {
  display: flex;
}

.box--bottom {
  width: 100%;
  max-width: var(--spacing-max-width-medium);
}

.box__footer  {
  display: flex;
  justify-content: center;
}

.bottom-image {
  background-image: url('../../static/img/login_bottom.jpg');
  margin: var(--spacing-large) 0 350px;
  padding-top: 100px;

  @media (--bp-desktop) {
    background-position-y: -60px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue